// import { Button } from "@mui/material";
// import { Box } from "@mui/system";
// import React, { useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import Footer from "./Footer";
// import Header from "./Header";
// import "./Thanks.css";

// const Thanks = () => {
//   const history = useHistory();

//   const routeToProducts = () => {
//     history.push("/");
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       history.push("/");
//     }
//   }, [history]);

//   return (
//     <>
//       <Header />
//       <Box className="greeting-container">
//         <h2>Yay! It's ordered 😃</h2>
//         <p>You will receive an invoice for your order shortly.</p>
//         <p>Your order will arrive in 7 business days.</p>
//         <p id="balance-overline">Wallet Balance</p>
//         <p id="balance">${localStorage.getItem("balance")} Available</p>
//         <Button
//           variant="contained"
//           size="large"
//           id="continue-btn"
//           onClick={routeToProducts}
//         >
//           Continue Shopping
//         </Button>
//       </Box>
//       <Footer />
//     </>
//   );
// };

// export default Thanks;
//////////////////////////////////////////////////////////////////////////

import { Button } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "./Thanks.css";

const Thanks = () => {
  const history = useHistory();

  const routeToProducts = () => {
    history.push("/");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      history.push("/");
    }
  }, [history]);

  return (
    <>
      <Header hasHiddenAuthButtons={true} />
      <Box className="greeting-container">
        <h2>Yay! It's ordered 😃</h2>
        <p>You will receive an invoice for your order shortly.</p>
        <p>Your order will arrive in 7 business days.</p>
        <p id="balance-overline">Wallet Balance</p>
        <p id="balance">${localStorage.getItem("balance")} Available</p>
        <Button
          variant="contained"
          size="large"
          id="continue-btn"
          onClick={routeToProducts}
        >
          Continue Shopping
        </Button>
      </Box>
      <Footer />
    </>
  );
};

export default Thanks;
